import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

import imgLibriPartner from './libri_partner_logo.png';

interface LibripartnerState extends BasePageState {}
interface LibripartnerModel {}

export default class LibripartnerPage extends Basepage<
  LibripartnerState,
  LibripartnerModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="">
        <br />
        <br />
        <b>HERZLICH WILLKOMMEN BEIM BUCHBUTLER</b>
        <br />
        <br />
        Ich freue mich, dass Sie der <b>Empfehlung von Libri</b>{' '}
        <img src={imgLibriPartner} title="Libri" height="32px" /> gefolgt sind
        und meinen B2B Bezugsservice on demand nutzen wollen.
        <br />
        <br />
        Bei mir können Sie{' '}
        <b>ohne Vertragsbindung und mit entsprechendem Händlerrabatt</b> auf das
        gesamte Titelangebot von Libri zugreifen. Mindestbestellmengen gibt es
        bei mir nicht. <br />
        Auch einmalige Bestellungen oder Bestellungen mit lediglich einem
        Artikel werden einfach, schnell und unkompliziert ausgeliefert.
        <br />
        <br />
        Sie können ganz <b>einfach</b> jetzt und hier den gewünschten Warenkorb
        zusammenstellen und <b>bestellen</b>. <br />
        Als Bezahlmöglichkeiten stehen Ihnen der Kauf auf Rechnung, die
        Bezahlung per Paypal oder mit Ihrer Kreditkarte zur Verfügung.
        <br />
        Optional ist selbstverständlich auch die Abrechnung Ihrer Bestellung
        über die BAG möglich.
        <br />
        <br />
        Die Auslieferung Ihrer Sendung erfolgt mit DHL oder der Deutschen Post.
        <br />
        <br />
        <br />
        Haben Sie Fragen?
        <br />
        <ul>
          <li>
            Rufen Sie gerne unseren persönlichen Kundenservice an:{' '}
            <a href="tel:+4925718072880">☎ 02571 / 8 07 28 80</a>
          </li>
          <li>
            Oder schreiben Sie uns eine E-Mail:{' '}
            <a href="mailto:service@buchbutler.de">service@buchbutler.de</a>
          </li>
        </ul>
        <br />
        <br />
        <br />
        <br />
        <br />
        <i>
          Bitte beachten Sie, dass eine Bestellung dazu führt, dass eine
          Referenz-ID, die Sie für Buchbutler eindeutig als Libri-Empfehlung
          identifizieren lässt, übermittelt wird. Sie haben jederzeit das Recht
          Widerspruch gegen diese Verarbeitung einzulegen. Weitere Informationen
          hierzu finden Sie in unserer{' '}
          <a href="https://www.buchbutler.de/datenschutz">
            Datenschutzerklärung
          </a>
          .
        </i>
      </div>
    );
  }
  initState(base: BasePageState): LibripartnerState {
    let newState: LibripartnerState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {
    let anyWin: any = window;
    if (anyWin.historyHelper == null) anyWin.historyHelper = {};

    anyWin.historyHelper.utm = {
      utm_campaign: 'LIBRIREC',
      utm_source: null,
      utm_medium: null,
    };
  }
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }
  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return '';
  }
  getBreadCrumb(): JSX.Element {
    return <></>;
  }
  getType(): string {
    return 'LibripartnerPage';
  }
}
